module.exports = "<div class=\"col-md-6 col-md-offset-3\">\n\t<div class=\"alert alert-warning\">\n\t\t<h2 class=\"text-center\">\n\t\t\t404 : Pagina non trovata!\n\t\t</h2>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/area-generale/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/components/area-generale/page-not-found/page-not-found.component.html
// module chunks = main